<div class="news_banner dis_flex align_stretch flex_wrap">
  <ng-container *ngFor="let news of data; let i = index">
    <div class="news_banner_item1 p-top-40" *ngIf="i === 0">
      <div
        class="border-radius-20 height_100_per cursor_pointer"
        (click)="goToNewsDetail(news.slug || news._id)"
      >
        <img
          class="news_banner_item1_img border-radius-20"
          [src]="news.imgPath"
          alt="Image"
        />
        <div class="news_banner_item1_body color_white">
          <div class="font_12 weight_500">
            <!-- {{news.createdAt|date}} -->
          </div>
          <div class="news_banner_item1_body_text p-top-8 font_18 weight_600">
            {{ news.title }}
          </div>
        </div>
      </div>
    </div>
    <div class="news_banner_item2 p-top-40 p-x-20" *ngIf="i !== 0">
      <div
        class="bg_1 border-radius-20 height_100_per cursor_pointer"
        (click)="goToNewsDetail(news.slug || news._id)"
      >
        <img
          class="news_banner_item2_img border-top-radius-20"
          [src]="news.imgPath"
          alt="Image"
          style="object-fit: cover"
        />
        <div
          class="bg_1 p-x-24 p-y-24 color_black border-bottom-radius-20"
          style="
            border-bottom-left-radius: 20px;
            border-bottom-right-radius: 20px;
          "
        >
          <div class="font_12 weight_500">
            <!-- {{news.createdAt|date}} -->
          </div>
          <div class="p-top-8 font_16 weight_600">
            {{ news.title }}
          </div>
        </div>
      </div>
    </div>
  </ng-container>
</div>
